import { createContext, useContext } from 'react';
import { Dimensions } from 'react-native';

interface ISizeLimitContext {
  width: number;
  height: number;
}

const SizeLimitContext = createContext<ISizeLimitContext>({
  width: Dimensions.get('window').width,
  height: Dimensions.get('window').height,
});

const useSizeLimitContext = () => {
  return useContext(SizeLimitContext);
};

export { useSizeLimitContext, SizeLimitContext };
